// @packages
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';

// @scripts
import { config } from '../../../../config';

// @styles
import styles from './styles';
import { DEFAULT_FIELD_VARIANT } from '../../../../styles/globals';

// @constants
const EMPTY_ERROR = ' ';

const CtrlMultiSelectField = ({
    allowUnselect,
    autoFocus,
    className,
    classes,
    disabled,
    id,
    itemDesProp,
    itemValProp,
    items,
    label,
    name,
    onBlur,
    onChange,
    onFocus,
    renderValue,
    required,
    showErrors,
    value,
    variant,
    visible
}) => {
    if (!visible) {
        return null;
    }

    const getErrorMsg = (value) => {
        if (required && !value) {
            return config.text.validations.required;
        }

        return EMPTY_ERROR;
    };

    const handleSelectOnChange = (evt) => {
        const { value } = evt.target;
        const item = items.find((item) => item[itemValProp] === value);

        onChange({
            description: item ? item[itemDesProp] : null,
            isValid: getErrorMsg(value) === EMPTY_ERROR,
            item,
            name: name || id,
            value: typeof value === 'string' ? value.split(',') : value,
        });
    };

    const selectFieldClass = classNames(
        className,
        classes.selectField
    );

    const selectFieldItems = allowUnselect
        ? [{ [itemValProp]: '', [itemDesProp]: '' }, ...items]
        : items;

    const errorMsg = getErrorMsg(value);
    const hasError = showErrors && errorMsg !== EMPTY_ERROR;
    //const helperText = hasError ? errorMsg : EMPTY_ERROR;

    return (
        <div>
            <InputLabel id={`${id}-label`} className={classes.multiSelectInputLabel}>{label}</InputLabel>
            <Select
                autoComplete="off"
                labelId={`${id}-label`}
                id={id}
                multiple
                value={value !== null ? value : []}
                onBlur={onBlur}
                onChange={handleSelectOnChange}
                onFocus={onFocus}
                input={<Input label={label} />}
                renderValue={(selected) => {
                    if (selected) {
                        let dat = [];
                        for (let i = 0; i <= selected.length - 1; i++) {
                            let d = selectFieldItems.find(x => x.id === selected[i]);
                            if (d) dat.push(d.description);
                        }
                        return dat.join(', ');
                    }
                }}
                //MenuProps={MenuProps}
                autoFocus={autoFocus}
                className={selectFieldClass}
                disabled={disabled}
                error={hasError}
                //helperText={helperText}
                //label={label}
                fullWidth
            //variant={variant}
            >
                {selectFieldItems.map((selectItem, index) => (
                    <MenuItem
                        id={`${id}-option-${index}`}
                        key={index}
                        value={selectItem[itemValProp]}>
                        <Checkbox checked={value.indexOf(selectItem[itemValProp]) > -1} />
                        {selectItem['toolTipText'] ?
                            <Tooltip key={`${index}-cer-tooltip`} title={selectItem['toolTipText']}>
                                <ListItemText primary={selectItem[itemDesProp]} />
                            </Tooltip> :
                            <ListItemText primary={selectItem[itemDesProp]} />
                        }
                    </MenuItem>
                ))}
            </Select>

        </div>
    );
};

CtrlMultiSelectField.propTypes = {
    allowUnselect: PropTypes.bool,
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    itemDesProp: PropTypes.string,
    itemValProp: PropTypes.string,
    items: PropTypes.array.isRequired,
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    renderValue: PropTypes.array,
    required: PropTypes.bool,
    showErrors: PropTypes.bool,
    value: PropTypes.array,//PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
    visible: PropTypes.bool
};

CtrlMultiSelectField.defaultProps = {
    allowUnselect: false,
    autoFocus: false,
    className: null,
    disabled: false,
    itemDesProp: 'description',
    itemValProp: 'id',
    label: null,
    name: null,
    onBlur: null,
    onFocus: null,
    renderValue: [],
    required: false,
    showErrors: true,
    value: [],
    variant: DEFAULT_FIELD_VARIANT,
    visible: true
};

export default withStyles(styles)(CtrlMultiSelectField);
